/**
 * 教师中心 - 试卷编辑页面
 * 
 * 复用后台PaperEditor组件，通过dataSource配置实现数据隔离
 */

import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { supabase } from '../../supabase/client';
import PaperEditor from '../admin/PaperEditor';
import { DEFAULT_TEACHER_DATASOURCE } from '../../hooks/usePaperDataSource';

export default function TeacherPaperEditor() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const editPaperId = searchParams.get('edit');
  const pendingPaperId = searchParams.get('pending');

  // 检查用户权限
  useEffect(() => {
    const checkAuth = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        navigate('/login');
        return;
      }

      const { data: profile } = await supabase
        .from('profiles')
        .select('role')
        .eq('id', user.id)
        .single();

      if (profile?.role !== 'teacher' && profile?.role !== 'admin') {
        navigate('/');
      }
    };

    checkAuth();
  }, [navigate]);

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      {/* 顶部导航栏 */}
      <div className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between shadow-sm">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate('/teacher/papers')}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors"
          >
            <ArrowLeft size={20} />
            <span className="font-medium">返回试卷列表</span>
          </button>
          <div className="h-6 w-px bg-gray-300" />
          <h1 className="text-lg font-semibold text-gray-800">
            {editPaperId ? '编辑试卷' : pendingPaperId ? '解析草稿' : '创建试卷'}
          </h1>
        </div>
        <div className="text-sm text-gray-500">
          教师专属数据空间
        </div>
      </div>

      {/* 试卷编辑器 - 使用后台PaperEditor组件，传入教师模式标识 */}
      <div className="flex-1 overflow-hidden">
        <PaperEditor isTeacherMode={true} />
      </div>
    </div>
  );
}
